import React, { useCallback, useState, useEffect } from 'react';

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: 'border-box'
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden',
  position: 'relative'
};

const img = {
  display: 'block',
  width: 'auto',
  height: '100%'
};

const delImg = {
  display: 'block',
  width: 'auto',
  height: '100%',
  opacity: '0.5'
};

const loadingImg = {
  display: 'block',
  width: 'auto',
  height: '100%',
  opacity: 0.5
};

export default function Thumb(props) {
  const { file } = props;
  const [status, setStatus] = useState(false);

  return <div style={thumb} key={`thumb-${props.id}`}>
    <div style={thumbInner}>
      <img
        src={file.preview}
        style={file.status === 'LOADING' ? loadingImg : (status ? delImg : img)}
        onClick={() => setStatus(!status)}
      />
      {status &&
      <div style={{ position: 'absolute', width: '100%', top: '50%', marginTop: '-25px', textAlign: 'center' }}>
        <h6 style={{ textShadow: '2px 2px white' }}>Usunąć?</h6>
        <a className="button tiny" onClick={props.onDelete}>TAK</a>
        <a className="button tiny secondary" onClick={() => setStatus(false)}>NIE</a>
      </div>}
    </div>
  </div>;
}
